// Google Workspace 監査の frontend データ層。カタログ正本は @cloud-checker/shared。
// スコア/重大度/カテゴリ別の算出ヘルパを提供する（SF と同方式: review/na は分母から除外）。
import { GW_AUDIT_CHECKS, GW_AUDIT_CATEGORIES, type GwCheck, type GwCategoryDef, type GwCheckCategory, type GwSeverity } from "@cloud-checker/shared";
import { SEVERITY_ORDER as UI_SEVERITY_ORDER } from "../ui/severity-badge";

export type { GwCheck, GwCategoryDef, GwCheckCategory, GwSeverity };
export const CHECKS: readonly GwCheck[] = GW_AUDIT_CHECKS;
export const CATEGORIES: readonly GwCategoryDef[] = GW_AUDIT_CATEGORIES;

export type FindingStatus = "pass" | "fail" | "na" | "review";
export interface Finding {
  readonly check: GwCheck;
  readonly status: FindingStatus;
  readonly affectedCount: number;
  readonly affectedResources: readonly string[];
  readonly lastDetected?: string;
}
export interface SeverityCounts { readonly critical: number; readonly high: number; readonly medium: number; readonly low: number; }

// 並び順は共有 ui/severity-badge を正本にする(SF と同一)。文言だけドメイン固有。
export const SEVERITY_ORDER: Record<GwSeverity, number> = UI_SEVERITY_ORDER;
export const SEVERITY_LABELS: Record<GwSeverity, string> = { critical: "致命的", high: "高", medium: "中", low: "低" };

export function computeSeverityCounts(findings: readonly Finding[]): SeverityCounts {
  const c = { critical: 0, high: 0, medium: 0, low: 0 };
  for (const f of findings) if (f.status === "fail") c[f.check.severity] += 1;
  return c;
}
// review/na は分母から除外（"pass と偽らない"。SF と同方式）。
export function computeScore(findings: readonly Finding[]): number {
  const pass = findings.filter((f) => f.status === "pass").length;
  const fail = findings.filter((f) => f.status === "fail").length;
  const denom = pass + fail;
  return denom === 0 ? 100 : Math.round((100 * pass) / denom);
}
export interface CategoryStat { readonly score: number; readonly pass: number; readonly fail: number; readonly na: number; readonly review: number; readonly total: number; }
export function categoryStats(findings: readonly Finding[], category: GwCheckCategory): CategoryStat {
  const inCat = findings.filter((f) => f.check.category === category);
  const pass = inCat.filter((f) => f.status === "pass").length;
  const fail = inCat.filter((f) => f.status === "fail").length;
  const na = inCat.filter((f) => f.status === "na").length;
  const review = inCat.filter((f) => f.status === "review").length;
  return { score: computeScore(inCat), pass, fail, na, review, total: inCat.length };
}
export function scoreBand(score: number): string {
  if (score >= 90) return "良好";
  if (score >= 70) return "概ね良好";
  if (score >= 50) return "要改善";
  return "要対応";
}
